import React, { Fragment, useCallback, useEffect, useState } from "react";
import styles from "./Printing.module.css";
import video from "../../Assets/printing/icons-and-background-video/Print Video black ink on white background.mp4";
import { Backdrop, Box, Container, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import time from "../../Assets/printing/icons-and-background-video/Time-icon.png";
import accuracy from "../../Assets/printing/icons-and-background-video/accuracy.png";
import colour from "../../Assets/printing/icons-and-background-video/colour.png";
import dpi from "../../Assets/printing/icons-and-background-video/dpi.png";
import panton from "../../Assets/printing/icons-and-background-video/panton colour.png";
import satin from "../../Assets/printing/Photo Satin/Photo-Satin.webp";
import satinpop from "../../Assets/printing/Photo Satin/Photo-Satin-popup.webp";
import matt from "../../Assets/printing/Photo Matt/Photo-Matt.webp";
import mattpop from "../../Assets/printing/Photo Matt/Photo-Matt-popup.webp";
import william from "../../Assets/printing/William Turner/William-Turner.webp";
import williampop from "../../Assets/printing/William Turner/William-Turner-popup.webp";
import german from "../../Assets/printing/German Etching/German-Etching.webp";
import germanpop from "../../Assets/printing/German Etching/German-Etching-popup.webp";
import pro from "../../Assets/printing/Pro Canvas/Pro Canvas.webp";
import propop from "../../Assets/printing/Pro Canvas/Pro-Canvas-popup.webp";
import soon from "../../Assets/printing/Coming Soon/comingsoon.webp";
import satisfaction from "../../Assets/Satisfaction Garanteed.png";
import delivery from "../../Assets/Delivery.png";
import customer from "../../Assets/Customer Service.png";
import trusted from "../../Assets/Trusted by expert.png";
import Parse from "../../API/ParseServer";
import { motion } from "motion/react";
import SplashCursor from "../../Components/UI/SplashCursor";
import CircularGallery, {
  CircularGalleryItem,
} from "../../Components/UI/CircularGallery";

const paperGalleryItems: CircularGalleryItem[] = [
  { image: satin, text: "", id: "satin" },
  { image: matt, text: "", id: "matt" },
  { image: william, text: "", id: "william" },
  { image: german, text: "", id: "german" },
  { image: pro, text: "", id: "pro" },
  { image: soon, text: "" },
];

const paperPopupImages: Record<string, string> = {
  satin: satinpop,
  matt: mattpop,
  william: williampop,
  german: germanpop,
  pro: propop,
};

const sizes = [
  [
    "A Sizes",
    ["A5", 15, 21],
    ["A4", 21, 30],
    ["A3", 30, 42],
    ["A3+", 33, 48],
    ["A2", 42, 59],
    ["A2+", 46, 61],
    ["A1", 59, 84],
    ["A0", 84, 119],
  ],
  ["Square", [20, 20], [30, 30], [41, 41], [51, 51], [76, 76], [102, 102]],
  [
    "Standard",
    [13, 18],
    [20, 25],
    [20, 30],
    [30, 41],
    [41, 51],
    [51, 76],
    [76, 102],
    [102, 152],
  ],
  [
    "Popular Frame Sizes",
    [10, 15],
    [13, 18],
    [28, 35],
    [30, 30],
    [30, 40],
    [40, 50],
    [50, 50],
    [50, 70],
    [70, 100],
  ],
  [
    "Popular Digital",
    [10, 15],
    [25, 38],
    [38, 51],
    [41, 61],
    [46, 61],
    [61, 91],
    [76, 114],
    [91, 137],
    [107, 142],
  ],
  ["Ultra Panaromic", [25, 76], [41, 122], [51, 152], [102, 305]],
  ["Panaromic", [25, 51], [41, 81], [51, 102], [76, 152], [102, 203]],
];
const Printing = () => {
  const [modal, setModal] = React.useState("");
  const handleClose = () => {
    setModal("");
  };
  const handlePaperClick = useCallback((item: CircularGalleryItem) => {
    if (item.id && paperPopupImages[item.id]) setModal(item.id);
  }, []);
  const activePopup = paperPopupImages[modal];
  const [unit, setUnit] = useState("inches");
  const [price, setPrice] = useState("inc VAT");
  const unitChangeHandler = (event: any) => {
    setUnit(event.target.id);
  };
  const priceChangeHandler = (event: any) => {
    setPrice(event.target.id);
  };
  const [pricing, setPricing] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    const fetchPricing = async () => {
      setLoading(true);
      const pricingQuery = new Parse.Query("Pricing");
      try {
        const results = await pricingQuery.find();
        setPricing(results[0]);
        console.log(results[0]);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPricing();
  }, []);
  const textVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 },
    },
  };
  const scaleVariants = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: (custom: any) => ({
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: "easeOut", delay: 0.2 * custom },
    }),
  };
  return (
    <Fragment>
      <video autoPlay muted id="video" className={styles.video}>
        <source src={video} />
      </video>
      {/* <SplashCursor
        DENSITY_DISSIPATION={3.5}
        VELOCITY_DISSIPATION={2}
        PRESSURE={0.1}
        CURL={3}
        SPLAT_RADIUS={0.2}
        SPLAT_FORCE={6000}
        COLOR_UPDATE_SPEED={0}
        // SHADING
        RAINBOW_MODE={false}
        // TRANSPARENT
        COLOR="#631886"
      /> */}
      <Container
        sx={{
          py: 6,
          // display: "flex",
          // flexDirection: "column",
          // alignItems: "center",
          // justifyContent: "space-between",
          // height: " calc(100vh - 6rem) ",
        }}
      >
        <Box
          sx={{
            color: "white",
            textAlign: "center",
            width: { xs: "100%", sm: "60%" },
            height: { xs: "60rem", sm: "120vh" },
          }}
        >
          <motion.div
            variants={textVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            custom={1}
          >
            {loading && error}
            <Typography variant="h3" component="h2">
              Professional<br></br> Photo & Art Printing
            </Typography>
            <Typography
              component="h3"
              variant="h5"
              sx={{ marginBottom: 5, marginTop: 3 }}
            >
              100% Guaranteed Satisfaction
            </Typography>
            <Typography>
              Utilising cutting-edge technology to create colour-accurate Giclée
              prints for you. Our hand-picked paper and canvas collection
              includes seven different types of professional and sustainable art
              papers, ranging from highly textured to smooth and matte to
              glossy.
              <br />
              <br />
              Highest Resolution With Vivid Colours
            </Typography>
            <Link to={"/upload"}>
              <button className={styles.button}>Start Printing</button>
            </Link>
          </motion.div>
        </Box>
        <Grid
          container
          sx={{ justifyContent: "center", textAlign: "center" }}
          spacing={3}
        >
          <Grid
            item
            xs={6}
            sm={12 / 5}
            sx={{
              display: "flex",
              flexDirection: "column",

              alignItems: "center",
            }}
          >
            <motion.div
              variants={scaleVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              custom={1}
            >
              <img src={time} alt="time" className={styles.icons} />
              <Typography variant="subtitle1">Archival Quality</Typography>
              <Typography variant="body2" sx={{ color: "#949494" }}>
                Up to 200 years
              </Typography>
            </motion.div>
          </Grid>
          <Grid
            item
            xs={6}
            sm={12 / 5}
            sx={{
              display: "flex",
              flexDirection: "column",

              alignItems: "center",
            }}
          >
            <motion.div
              variants={scaleVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              custom={2}
            >
              <img src={dpi} alt="dpi" className={styles.icons} />
              <Typography variant="subtitle1">Highest Resolution</Typography>
              <Typography variant="body2" sx={{ color: "#949494" }}>
                1,200 x 2,400 DPI
              </Typography>
            </motion.div>
          </Grid>
          <Grid
            item
            xs={6}
            sm={12 / 5}
            sx={{
              display: "flex",
              flexDirection: "column",

              alignItems: "center",
            }}
          >
            <motion.div
              variants={scaleVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              custom={3}
            >
              <img src={colour} alt="colour" className={styles.icons} />
              <Typography variant="subtitle1">12 Inks</Typography>
              <Typography variant="body2" sx={{ color: "#949494" }}>
                Archival Pigment Based
              </Typography>
            </motion.div>
          </Grid>
          <Grid
            item
            xs={6}
            sm={12 / 5}
            sx={{
              display: "flex",
              flexDirection: "column",

              alignItems: "center",
            }}
          >
            <motion.div
              variants={scaleVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              custom={4}
            >
              <img src={accuracy} alt="accuracy" className={styles.icons} />
              <Typography variant="subtitle1">
                Vibrant, Detailed & Sharp
              </Typography>
              <Typography variant="body2" sx={{ color: "#949494" }}>
                UltraChrome Technology
              </Typography>
            </motion.div>
          </Grid>
          <Grid
            item
            xs={6}
            sm={12 / 5}
            sx={{
              display: "flex",
              flexDirection: "column",

              alignItems: "center",
            }}
          >
            <motion.div
              variants={scaleVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.5 }}
              custom={5}
            >
              <img src={panton} alt="panton" className={styles.icons} />
              <Typography variant="subtitle1">Widest Colour Gamut</Typography>
              <Typography variant="body2" sx={{ color: "#949494" }}>
                99% Pantone Coverage
              </Typography>
            </motion.div>
          </Grid>
        </Grid>
      </Container>
      <Box
        sx={{ width: "100%", backgroundColor: "#fbfbfb", py: 5 }}
        id="handpicked"
      >
        <Container sx={{ textAlign: "center" }} maxWidth='xl' >
          <motion.div
            variants={textVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
          >
            <Typography variant="h4" component="h2">
              Hand-picked selection of high quality papers and canvas
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: "#a3a3a3", marginBottom: 5, marginTop: 3 }}
            >
              Utilising the latest Epson UltraChrome precision core printers
              with 12 archival quality pigment inks to produce professional
              Giclée prints. This service is suitable for reproductions of
              photographs, illustrations, paintings, architectural plans or even
              posters that requires maximum detail and longevity
            </Typography>
          </motion.div>
          <Backdrop
            sx={(theme) => ({
              color: "#fff",
              zIndex: theme.zIndex.drawer + 1,
            })}
            open={Boolean(activePopup)}
            onClick={handleClose}
          >
            <Box
              sx={{
                backgroundColor: "white",
                width: { xs: "95vw", sm: "35rem" },
                height: { xs: "95vw", sm: "35rem" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {activePopup && (
                <img
                  src={activePopup}
                  alt={`${modal} paper sample`}
                  className={styles["poster-backdrop"]}
                />
              )}
            </Box>
          </Backdrop>

          <Box className={styles.paperGallery}>
            <CircularGallery
              items={paperGalleryItems}
              bend={0}
              borderRadius={0}
              textColor="#34312f"
              font='600 24px "Roboto", sans-serif'
              scrollSpeed={2}
              scrollEase={0.065}
              onItemClick={handlePaperClick}
              paperEffect
              ariaLabel="Paper and canvas samples. Drag to browse, then click a sample to enlarge it."
            />
          </Box>
          <Typography className={styles.galleryHint} variant="body2">
            Drag to browse · click a paper to view its full sample
          </Typography>
        </Container>
      </Box>
      <Box sx={{ width: "100%", backgroundColor: "#d9d9d9", py: 5 }}>
        <Container sx={{ textAlign: "center" }}>
          <Grid container spacing={7}>
            <Grid item xs={12} sm={6} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={1}
              >
                <img
                  src={satisfaction}
                  alt="satisfaction"
                  className={styles.icons}
                />
                <Typography variant="subtitle1">
                  Satisfaction Guaranteed
                </Typography>
                <Typography variant="caption" sx={{ color: "#949494" }}>
                  100% guaranteed satisfaction. We go above and beyond to make
                  you happy with our service, and your satisfaction is our goal.
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={2}
              >
                <img src={delivery} alt="delivery" className={styles.icons} />
                <Typography variant="subtitle1">Reliable Delivery </Typography>
                <Typography variant="caption" sx={{ color: "#949494" }}>
                  Reliable and express delivery service national wide
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={3}
              >
                <img src={customer} alt="customer" className={styles.icons} />
                <Typography variant="subtitle1">
                  Great Customer Service
                </Typography>
                <Typography variant="caption" sx={{ color: "#949494" }}>
                  Constantly improving our services to make it easier for you to
                  have a more enjoyable experience coing our services
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <motion.div
                variants={scaleVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
                custom={4}
              >
                <img src={trusted} alt="trusted" className={styles.icons} />
                <Typography variant="subtitle1">
                  Trusted by Professionals
                </Typography>
                <Typography variant="caption" sx={{ color: "#949494" }}>
                  Working with the bests in the field of art and framing has
                  made us an attractive choice for collectors, auctioneers and
                  art enthusiasts
                </Typography>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{ width: "100%", backgroundColor: "#f3f2f1", py: 5 }}>
        <Container>
          <Grid container spacing={8}>
            <Grid item xs={12} md={6}>
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography variant="h4" component="h2">
                  What is Giclée Printing?
                </Typography>
                <Typography sx={{ color: "#9e9e9d", marginTop: 4 }}>
                  The word Giclée ("gee-clay"), is based on the French word
                  giclee which means "to squirt or to spray and was originally
                  mentioned by printmaker Jack Duganne in 1991. Giclée printing
                  is a fine art digital printing process using specialist
                  archival pigment inks and acid-free papers; creating
                  gallery-quality inkjet prints with excellent depth of colour,
                  longevity and stability.
                  <br />
                  <br />
                  The print process involves squirting microscopic dots of
                  pigment ink onto high quality fine art or photographic papers
                  using sophisticated high-end inkjet printers with exceptional
                  accuracy, wide tonal range and colour gamut.
                  <br />
                  <br />
                  Studies have shown that the vivid colours in Giclée Prints can
                  last more than 200 years with tests by independent bodies such
                  as Wilhelm Research and printer manufacturers such as Canon.
                  This gives assurance to artists, photographers, collectors and
                  art buyers of the high quality of these types of prints.
                  Giclée printing is a type of inkjet printing - but
                  importantly, not all inkjet prints are giclée prints. Giclée
                  printing produces a product at a higher quality and with a
                  much longer lifespan than a standard desktop inkjet printers.
                </Typography>
              </motion.div>
            </Grid>
            <Grid item xs={12} md={6}>
              <motion.div
                variants={textVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.5 }}
              >
                <Typography variant="h4" component="h2">
                  Why Giclée?
                </Typography>
                <Typography sx={{ color: "#9e9e9d", marginTop: 4 }}>
                  <ul className={styles.list}>
                    <li>
                      Has greater accuracy and depth of colour, ensuring
                      faithful reproductions of originals. There are more vivid
                      and saturated colours than C-Type or digital offset, due
                      to the bright pigments used to make up the inks.
                    </li>
                    <br />
                    <li>
                      A perfect solution for artists and photographers who do
                      not wish to go to the expense of mass-producing their work
                      using more commercial based printers but prefer to print
                      on demand.
                    </li>
                    <br />
                    <li>
                      Print on demand means a single artwork can be made
                      available in many papers and finishes and at different
                      sizes. There are a much greater number of papers to choose
                      from, incorporating different weights, textures and
                      whiteness,
                    </li>
                    <br />
                    <li>
                      4. Better longevity; a giclée print will outlast other
                      prints and technologies by up to six times. The numerous
                      research done by the independent Wilhelm Research group
                      provides supporting data and evidence for this claim.
                    </li>
                    <br />
                    <li>
                      Once Framed, their longevity doubles and with a UV
                      filtered glass multiplies which preserves the prints and
                      maintains the vivid colours of image.
                    </li>
                    <br />
                    <li>
                      Widely accepted by art buyers, galleries and museums as
                      archival, collectable art pieces.
                    </li>
                  </ul>
                </Typography>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Container sx={{ py: 10 }}>
        <Grid container spacing={5}>
          <Grid item xs={6} md={4}>
            <Typography
              sx={{
                width: "100%",
                borderBottom: "2px solid #d5d5d5",
                paddingBottom: 1,
              }}
              variant="h6"
            >
              Units
            </Typography>
            <Box
              sx={{ display: "flex", gap: 2, color: "#c2c2c2", marginTop: 2 }}
            >
              <p
                style={{
                  margin: "0",
                  color: `${unit === "inches" ? "black" : "#c2c2c2"}`,
                  cursor: "pointer",
                }}
                onClick={unitChangeHandler}
                id="inches"
              >
                inches
              </p>
              <p
                style={{
                  margin: "0",
                  color: `${unit === "mm" ? "black" : "#c2c2c2"}`,
                  cursor: "pointer",
                }}
                onClick={unitChangeHandler}
                id="mm"
              >
                mm
              </p>
              <p
                style={{
                  margin: "0",
                  color: `${unit === "cm" ? "black" : "#c2c2c2"}`,
                  cursor: "pointer",
                }}
                onClick={unitChangeHandler}
                id="cm"
              >
                cm
              </p>
            </Box>
          </Grid>
          <Grid item xs={6} md={4}>
            <Typography
              sx={{
                width: "100%",
                borderBottom: "2px solid #d5d5d5",
                paddingBottom: 1,
              }}
              variant="h6"
            >
              Price
            </Typography>
            <Box
              sx={{ display: "flex", gap: 2, color: "#c2c2c2", marginTop: 2 }}
            >
              <p
                style={{
                  margin: "0",
                  color: `${price === "inc VAT" ? "black" : "#c2c2c2"}`,
                  cursor: "pointer",
                }}
                onClick={priceChangeHandler}
                id="inc VAT"
              >
                inc VAT
              </p>
              <p
                style={{
                  margin: "0",
                  color: `${price === "exc VAT" ? "black" : "#c2c2c2"}`,
                  cursor: "pointer",
                }}
                onClick={priceChangeHandler}
                id="exc VAT"
              >
                exc VAT
              </p>
            </Box>
          </Grid>
          <Grid xs={0} md={4}></Grid>
          {sizes.map((size: any, index) => {
            if (index === 0)
              return (
                <Grid item xs={12} sm={6} md={4}>
                  {size.map((item: any, index: any) => {
                    if (index === 0)
                      return (
                        <Typography
                          sx={{
                            width: "100%",
                            borderBottom: "2px solid #d5d5d5",
                            paddingBottom: 1,
                          }}
                          variant="h6"
                        >
                          {item}
                        </Typography>
                      );
                    else
                      return (
                        <Box
                          sx={{
                            display: "flex",
                            marginTop: 2,
                            borderBottom: "2px solid #d5d5d5",
                          }}
                        >
                          <Typography
                            sx={{ marginRight: 1, fontWeight: "bolder" }}
                            // variant="subtitle1"
                          >
                            {item[0]}
                          </Typography>
                          <Typography>
                            {unit === "cm"
                              ? `${item[1]}x${item[2]} cm`
                              : unit === "mm"
                                ? `${item[1] * 10}x${item[2] * 10} mm`
                                : unit === "inches" &&
                                  `${(item[1] / 2.54).toFixed(1)}x${(
                                    item[2] / 2.54
                                  ).toFixed(1)} in`}
                          </Typography>
                          <Typography
                            sx={{ marginLeft: "auto", fontWeight: "bolder" }}
                          >
                            ₤
                            {pricing &&
                              (price === "exc VAT"
                                ? (
                                    2e-16 *
                                      Math.pow(
                                        Number(
                                          item[1] *
                                            item[2] *
                                            Number(pricing.get("paper_cm2")),
                                        ),
                                        4,
                                      ) +
                                    1e-11 *
                                      Math.pow(
                                        Number(
                                          item[1] *
                                            item[2] *
                                            Number(pricing.get("paper_cm2")),
                                        ),
                                        3,
                                      ) -
                                    1e-7 *
                                      Math.pow(
                                        Number(
                                          item[1] *
                                            item[2] *
                                            Number(pricing.get("paper_cm2")),
                                        ),
                                        2,
                                      ) +
                                    0.0117 *
                                      Number(
                                        item[1] *
                                          item[2] *
                                          Number(pricing.get("paper_cm2")),
                                      ) +
                                    3.5525
                                  )
                                    // +
                                    // Math.pow(
                                    //   Number(item[1] * item[2] * 100),
                                    //   0.834
                                    // ) *
                                    //   (Number(pricing.get("paper_cm2")) || 1) *
                                    //   0.00121
                                    .toFixed(2)
                                : (
                                    (2e-16 *
                                      Math.pow(
                                        Number(
                                          item[1] *
                                            item[2] *
                                            Number(pricing.get("paper_cm2")),
                                        ),
                                        4,
                                      ) +
                                      1e-11 *
                                        Math.pow(
                                          Number(
                                            item[1] *
                                              item[2] *
                                              Number(pricing.get("paper_cm2")),
                                          ),
                                          3,
                                        ) -
                                      1e-7 *
                                        Math.pow(
                                          Number(
                                            item[1] *
                                              item[2] *
                                              Number(pricing.get("paper_cm2")),
                                          ),
                                          2,
                                        ) +
                                      0.0117 *
                                        Number(
                                          item[1] *
                                            item[2] *
                                            Number(pricing.get("paper_cm2")),
                                        ) +
                                      3.5525) *
                                    (1 + pricing.get("VAT") || 0.2)
                                  ).toFixed(2))}
                          </Typography>
                        </Box>
                      );
                  })}
                </Grid>
              );
            else
              return (
                <Grid item xs={12} sm={6} md={4}>
                  {size.map((item: any, index: any) => {
                    if (index === 0)
                      return (
                        <Typography
                          sx={{
                            width: "100%",
                            borderBottom: "2px solid #d5d5d5",
                            paddingBottom: 1,
                          }}
                          variant="h6"
                        >
                          {item}
                        </Typography>
                      );
                    else
                      return (
                        <Box
                          sx={{
                            display: "flex",
                            marginTop: 2,
                            borderBottom: "2px solid #d5d5d5",
                          }}
                        >
                          <Typography>
                            {unit === "cm"
                              ? `${item[0]}x${item[1]} cm`
                              : unit === "mm"
                                ? `${item[0] * 10}x${item[1] * 10} mm`
                                : unit === "inches" &&
                                  `${item[0] * 1.5}x${item[1] * 1.5} in`}
                          </Typography>
                          <Typography
                            sx={{ marginLeft: "auto", fontWeight: "bolder" }}
                          >
                            ₤
                            {pricing &&
                              (price === "exc VAT"
                                ? (
                                    2e-16 *
                                      Math.pow(
                                        Number(
                                          item[0] *
                                            item[1] *
                                            Number(pricing.get("paper_cm2")),
                                        ),
                                        4,
                                      ) +
                                    1e-11 *
                                      Math.pow(
                                        Number(
                                          item[0] *
                                            item[1] *
                                            Number(pricing.get("paper_cm2")),
                                        ),
                                        3,
                                      ) -
                                    1e-7 *
                                      Math.pow(
                                        Number(
                                          item[0] *
                                            item[1] *
                                            Number(pricing.get("paper_cm2")),
                                        ),
                                        2,
                                      ) +
                                    0.0117 *
                                      Number(
                                        item[0] *
                                          item[1] *
                                          Number(pricing.get("paper_cm2")),
                                      ) +
                                    3.5525
                                  ).toFixed(2)
                                : (
                                    (2e-16 *
                                      Math.pow(
                                        Number(
                                          item[0] *
                                            item[1] *
                                            Number(pricing.get("paper_cm2")),
                                        ),
                                        4,
                                      ) +
                                      1e-11 *
                                        Math.pow(
                                          Number(
                                            item[0] *
                                              item[1] *
                                              Number(pricing.get("paper_cm2")),
                                          ),
                                          3,
                                        ) -
                                      1e-7 *
                                        Math.pow(
                                          Number(
                                            item[0] *
                                              item[1] *
                                              Number(pricing.get("paper_cm2")),
                                          ),
                                          2,
                                        ) +
                                      0.0117 *
                                        Number(
                                          item[0] *
                                            item[1] *
                                            Number(pricing.get("paper_cm2")),
                                        ) +
                                      3.5525) *
                                    (1 + pricing.get("VAT") || 0.2)
                                  ).toFixed(2))}
                          </Typography>
                        </Box>
                      );
                  })}
                </Grid>
              );
          })}
        </Grid>
      </Container>
    </Fragment>
  );
};

export default Printing;
